import React from "react";
import { Box } from "@mui/material";

interface FormPageImageProps {
  src: string;
  alt: string;
}

const FormPageImage: React.FC<FormPageImageProps> = ({ src, alt }) => (
  <Box
    sx={{
      flex: 1,
      overflow: "hidden",
      zIndex: -1,
      display: { xs: "none", md: "block" },
    }}
  >
    <img
      src={src}
      alt={alt}
      style={{
        width: "100%",
        height: "100%",
        objectFit: "cover",
      }}
    />
  </Box>
);

export default FormPageImage;
